import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Administrator } from './Administrator';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  usermail: string;
  password: string;
  errorMessage: string;
  administrator: Administrator;
  
  public loading =  false;

  constructor(private router: Router, private loginService: LoginService, private toaster: ToastrService) {}

  ngOnInit() {
    this.loading = true;
    console.log('Initiating login page');
    setTimeout(()=>{
      this.loading = false;
    }, 3000);
  }

  captureCredential() {
    if (this.usermail == null && this.password == null) {
      this.toaster.info('AUCDT info','*Email and Password are required.',{
        positionClass: 'toast-top-center', 
      });
    } else if (this.usermail === undefined) {
      this.toaster.info('AUCDT info','*Email is required!',{
        positionClass: 'toast-top-center',
      });
    } else if (this.password === undefined) {
      this.toaster.info('AUCDT info','*Password is required!',{
        positionClass: 'toast-top-center',
      });
    } else if (this.usermail.trim() == '' && this.password.trim() == '') {
      this.toaster.info('AUCDT info','*Email and Password are required!',{
        positionClass: 'toast-top-center'
        });

    } else if (this.usermail == null || this.usermail.trim() == '') {
      // validate for blank username field
      this.toaster.info('AUCDT info','*Email is required!',{
        positionClass: 'toast-top-center'
      });

    } else if (this.password == null || this.password.trim() == '') {
      // validate for blank password field
      this.toaster.info('AUCDT info','*Password is required!',{
        positionClass: 'toast-top-center'
      });

      
    } else {
      this.loginService
        .getAdminstratorDetails(this.usermail, this.password)
        .subscribe((response) => {
          this.administrator = response;
          if (this.administrator !== null) {
            var localStorage = window['localStorage'];
            localStorage.clear();
            localStorage.setItem(
              'administratorId',
              this.administrator.administratorId,
            );
            localStorage.setItem('usermail', this.usermail);
            localStorage.setItem('password', this.password);
            this.loading=true; 
            this.toaster.success('success', 'Successfully logged in!',{
              positionClass: 'toast-top-center',
            });
            setTimeout(()=>{
              this.loading = false;
              this.router.navigateByUrl('/dashboard');
            }, 3000);
          } else {
            this.toaster.error('error', '*Invalid Email and Password provided.',{
              positionClass: 'toast-top-center',
            });
          }
        });
    }
  }
}
